import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function WifiIcon({ color = "purple" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.225 15.75L11.925 12.15C11.175 11.5875 10.2375 11.25 9.225 11.25C8.2125 11.25 7.275 11.5875 6.525 12.15L9.225 15.75ZM9.225 2.25C6.1875 2.25 3.3825 3.255 1.125 4.95L2.475 6.75C4.35 5.34 6.69 4.5 9.225 4.5C11.76 4.5 14.1 5.34 15.975 6.75L17.325 4.95C15.0675 3.255 12.2625 2.25 9.225 2.25ZM9.225 6.75C7.2 6.75 5.3325 7.4175 3.825 8.55L5.175 10.35C6.3 9.5025 7.7025 9 9.225 9C10.7475 9 12.15 9.5025 13.275 10.35L14.625 8.55C13.1175 7.4175 11.25 6.75 9.225 6.75Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
